<template>
  <div class="card member-wedges-card">
    <div class="card-body p-0">
      <div id="map" dir="ltr" style="height: 287px"></div>
    </div>

    <div class="card-footer p-0 d-flex text-uppercase" style="cursor: pointer;">
      <div class="bg-success col-2" @click="gotTo('active_users')">
        <div class="p-3">
          <p class="font-size-5 text-white p text-truncate mb-0 d-flex align-items-center fw-semibold">
            Active Collectors
            <button data-toggle="modal" data-target="#helpModal" title="What does being Active mean?" type="button" class="btn btn-link waves-effect">
              <i class="bx bx-help-circle text-white fs-"></i>
            </button>
          </p>
          <h5 class="text-white m-0">{{numberFormat(performanceSummary.active)}}</h5>
        </div>
      </div>

      <div class="bg-warning col-2" @click="gotTo('offline_users')">
        <div class="p-3">
          <p class="font-size-10 text-white p text-truncate mb-0 d-flex align-items-center fw-semibold">
            Inactive Collectors
            <button data-toggle="modal" data-target="#helpModal" title="What does being inactive mean?" type="button" class="btn btn-link waves-effect">
              <i class="bx bx-help-circle text-white fs-"></i>
            </button>
          </p>
          <h5 class="text-white m-0">{{numberFormat(performanceSummary.offline)}}</h5>
        </div>
      </div>

      <div class="bg-danger col-2" @click="gotTo('dormant_users')">
        <div class="p-3">
          <p class="font-size-10 text-white text-truncate pb-0 mb-0 d-flex align-items-center fw-semibold">
            Dormant Collectors
            <button data-toggle="modal" data-target="#helpModal" title="What does being inactive mean?" type="button" class="btn btn-link waves-effect">
              <i class="bx bx-help-circle text-white fs-"></i>
            </button>
          </p>
          <h5 class="text-white m-0">{{numberFormat(performanceSummary.dormant)}}</h5>
        </div>
      </div>

      <div class="bg-black col-3" @click="gotTo('live_monitoring')">
        <div class="p-3">
          <p class="font-size-10 text-white text-truncate pb-0 mb-0 d-flex align-items-center fw-semibold">
            All Collectors
            <button data-toggle="modal" data-target="#helpModal" title="What does being inactive mean?" type="button" class="btn btn-link waves-effect">
              <i class="bx bx-help-circle text-white fs-"></i>
            </button>
          </p>
          <h5 class="text-white m-0">{{numberFormat(performanceSummary.allUsers)}}</h5>
        </div>
      </div>

      <div class="bg-info col-3" @click="gotTo('live_monitoring')">
        <div class="p-3">
          <p class="font-size-10 text-white text-truncate pb-0 mb-0 d-flex align-items-center fw-semibold">
            Others
            <button data-toggle="modal" data-target="#helpModal" title="What does being inactive mean?" type="button" class="btn btn-link waves-effect">
              <i class="bx bx-help-circle text-white fs-"></i>
            </button>
          </p>
          <h5 class="text-white m-0">{{numberFormat(performanceSummary.otherUsers)}}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, execute } from "@/api";
import router from "@/router";
import moment from 'moment';

export default {
  name: "CollectorsPerformanceCard",
  data() {
    return {
      users: [],
      county: {
        lat: null,
        lng: null
      },
      performanceSummary: {
        active: 0,
        offline: 0,
        dormant: 0,
        allUsers: 0,
        otherUsers: 0
      }
    }
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },
    gotTo(route) {
      router.push(route);
    },
    getUsers() {
      const data = new FormData();
      data.append("function", "getDashboardUsers");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.users = res.data.data.users;
              this.county = res.data.data.county;
              this.performanceSummary = res.data.data.performanceSummary;
              this.initMap();
            } else {
              if (res.data.status === 401) {
                alert(res.data.message);
              }
            }
          })
          .catch((e) => {
            console.error(e.message);
          });
    },
    humanDateTimeAgo(date) {
      return moment(date).fromNow();
    },
    formattedTime(time) {
      return moment(time).format('hh:mm A');
    },
    getStatus(time) {
      const now = Date.now();
      const then = Date.parse(time);
      const elapsedHours = (now - then) / 3600000;

      if (elapsedHours < 2) {
        return "Active";
      } else if (elapsedHours < 72) {
        return "Inactive";
      } else {
        return "Dormant";
      }
    },
    getMarkerIcon(category, userStatus) {
      // Define icon URLs based on category and status
      const icons = {
        COLLECTOR: {
          Active: "assets/images/users/active-agent.png",
          Inactive: "assets/images/users/inactive-agent.png",
          Dormant: "assets/images/users/dormant-agent.png"
        },
        DEFAULT: {
          Active: "assets/images/users/active-agent.png",
          Inactive: "assets/images/users/inactive-agent.png",
          Dormant: "assets/images/users/dormant-agent.png"
        }
      };

      const categoryIcons = icons[category] || icons.DEFAULT;
      return categoryIcons[userStatus] || categoryIcons.Dormant;
    },
    initMap() {
      const latitude = parseFloat(this.county.lat);
      const longitude = parseFloat(this.county.lng);

      let map = new google.maps.Map(document.getElementById("map"), {
        zoom: 13,
        center: { lat: latitude, lng: longitude }
      });

      this.users.forEach((item) => {
        // Skip users with invalid coordinates
        if (!item.lat || !item.lng || item.lat === '' || item.lng === '') {
          return;
        }

        const person = { lat: Number(item.lat), lng: Number(item.lng) };

        // Validate coordinates are valid numbers
        if (isNaN(person.lat) || isNaN(person.lng)) {
          return;
        }

        const marker = new google.maps.Marker({
          position: person,
          map: map,
        });

        let batteryLevel;
        if (typeof item.battery === "string" && item.battery.includes(":")) {
          batteryLevel = item.battery.split(":")[1];
        } else {
          batteryLevel = "0%";
        }

        // Get status color class
        let statusClass = '';
        let userStatus = this.getStatus(item.lastSeen);
        if (userStatus === 'Active') {
          statusClass = 'text-success';
        } else if (userStatus === 'Inactive') {
          statusClass = 'text-warning';
        } else {
          statusClass = 'text-danger';
        }

        const infowindow = new google.maps.InfoWindow({
          content: `
            <div style="max-width: 300px;">
              <p class="mb-1">
                <span class="badge bg-primary">${item.category}</span>
                <span class="badge ${item.status === 'Active' ? 'bg-success' : item.status === 'Disabled' ? 'bg-secondary' : 'bg-danger'}">${item.status}</span>
              </p>
              <p class="mb-1">Zone: ${item.zone || 'Not assigned'} | <a href="tel:${item.phoneNumber}">${item.phoneNumber}</a></p>
              <h6 class="text-capitalize d-flex align-items-center mb-1">
                <span class="offline-agent mr-2"></span>
                <span>${item.names} <small class="${statusClass}"><strong>(${userStatus}) ${this.humanDateTimeAgo(item.lastSeen)}</strong></small></span>
              </h6>
              <p class="pb-0 mb-1">Last seen at <strong>${item.address || 'Unknown location'}</strong> at ${this.formattedTime(item.lastSeen)}</p>
              <p class="mb-0">Most recent activity: <strong>${item.des || 'N/A'}</strong></p>
            </div>
          `,
        });

        // Get appropriate icon based on category and status
        let url = this.getMarkerIcon(item.category, userStatus);

        var agent = {
          url: url,
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(0, 0),
          scaledSize: new google.maps.Size(19, 40)
        };

        marker.setIcon(agent);
        marker.addListener("mouseover", () => {
          infowindow.open(map, marker);
        });
        marker.addListener("mouseout", () => {
          infowindow.close();
        });
      });
    }
  }
}
</script>